import { render, staticRenderFns } from "./totalSalesCollectionsYTD.vue?vue&type=template&id=3aad2e86&"
import script from "./totalSalesCollectionsYTD.vue?vue&type=script&lang=js&"
export * from "./totalSalesCollectionsYTD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports